import { PriceChartDuration } from "./price-chart";

export interface CandleSticks {
  currencyRateSymbol: String;
  data: CandleStickItem[];
  pair: String;
}

export const CandleStickIntervals = {
  [PriceChartDuration.OneDay]: 60 * 60 * 24, // 1 day
  [PriceChartDuration.SevenDays]: 60 * 60 * 24 * 7, // 7 Days
  [PriceChartDuration.OneMonth]: 60 * 60 * 24 * 30, // 1 Month
  [PriceChartDuration.ThreeMonths]: 60 * 60 * 24 * 30 * 3, // 3 Months
  [PriceChartDuration.OneYear]: 60 * 60 * 24 * 30 * 12, // 1 Year
};

export const CandleStickResolutions = {
  [PriceChartDuration.OneDay]: 60 * 30, // 30 Minutes
  [PriceChartDuration.SevenDays]: 60 * 60, // 1 Hour
  [PriceChartDuration.OneMonth]: 60 * 60 * 6, // 6 Hours
  [PriceChartDuration.ThreeMonths]: 60 * 60 * 12, // 12 Hours
  [PriceChartDuration.OneYear]: 60 * 60 * 24, // 1 Day
};

export interface CandleStickRequest {
  startTime: string,
  endTime: string,
  inCurrency: string, // if empty gives value in USD else in the requested currency
  pair: string,
  intervalInSeconds: number
}

export interface CandleStickItem {
  c: string;
  h: string;
  l: string;
  o: string;
  v: string;
  t: string;
  cc?: string;
  ch?: string;
  cl?: string;
  co?: string;
  cv?: string;
}